//
//
//
//
//
//
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import { queryUrlBySiteId } from '@api/api';
import Vue from 'vue';
import { ACCESS_TOKEN } from "@/store/mutation-types";
export default {
  data: function data() {
    return {
      frameUrl: '',
      widthChange: true,
      timer: null
    };
  },
  mixins: [GetSiteIdMixin],
  watch: {
    currentSiteId: function currentSiteId(value) {
      var _this = this;

      console.log('value', value); // this.showState = false
      // this.$nextTick(()=>{
      // this.showState = true

      var ids = this.getTreeCurrentId();

      if (ids[0] == 1) {
        // this.frameUrl = `http://192.168.8.132:5000/view/yesep_iws/115`
        queryUrlBySiteId(value).then(function (res) {
          if (res.result) {
            _this.frameUrl = res.result;
          } else {
            _this.frameUrl = 'https://3d.yesep.online/view/yesep_env/3?site_id=' + value + '&isCron=1&token=' + Vue.ls.get(ACCESS_TOKEN);
          }
        }).catch(function () {
          _this.frameUrl = 'https://3d.yesep.online/view/yesep_env/3?site_id=' + value + '&isCron=1&token=' + Vue.ls.get(ACCESS_TOKEN);
        });
      } // this.frameUrl = 
      // })


      console.log('ids', ids);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    window.addEventListener('resize', function () {
      _this2.widthChange = false;
      _this2.timer = setTimeout(function () {
        _this2.widthChange = true;
      }, 100);
    }, false);
    window.addEventListener('message', this.handleMessage);
  },
  destroyed: function destroyed() {
    clearTimeout(this.timer);
    window.removeEventListener('message', this.handleMessage);
  },
  methods: {
    handleMessage: function handleMessage(e) {
      eval("(" + e.data.data + ")");
    }
  }
};